import { getSite } from '../../application/pageDataObject'
import { getCountryCode } from '../../providers/geolocationProvider'
import { changeLogo } from '../../store/logo/logo.actions'
import { dispatch } from '../../application/appStore'
import { getCampaignsFromCampaignManagerService } from '../../providers/campaignManager/campaignManagerProvider'

//TODO(Jonathan) - Remove. it's an experiment to test plumbus service
async function getCampaignsFromCampaignManager() {
  const countryCode = await getCountryCode()
  return await getCampaignsFromCampaignManagerService(getSite(), countryCode, new Date())
}

export default function initLogoMorph() {
  return getCampaignsFromCampaignManager().then(campaigns =>
    campaigns
      .filter(campaign => campaign.type === 'LogoMorph')
      .forEach(campaign => dispatch(changeLogo(campaign.payload.src)))
  )
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/logoMorphInitializer.js